import { JUICE } from "./config.js";

export interface Shake {
  add(intensity: number): void;
  update(dt: number): void;
  readonly offsetX: number;
  readonly offsetY: number;
}

/**
 * Sacudida de camara estilo trauma shake. El trauma decae exponencialmente;
 * el offset es aleatorio cada frame (solo render, no afecta al determinismo).
 */
export function createShake(): Shake {
  let trauma = 0;
  let offsetX = 0;
  let offsetY = 0;

  return {
    add(intensity: number): void {
      trauma = Math.min(JUICE.SHAKE.MAX, trauma + intensity);
    },

    update(dt: number): void {
      trauma *= Math.exp(-JUICE.SHAKE.DECAY * dt);
      const amount = trauma * trauma * JUICE.SHAKE.MAX_OFFSET;
      offsetX = (Math.random() * 2 - 1) * amount;
      offsetY = (Math.random() * 2 - 1) * amount;
    },

    get offsetX() {
      return offsetX;
    },

    get offsetY() {
      return offsetY;
    },
  };
}
